import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const BigBrandsZeroCarbon = () => {
  const { t } = useLanguage();

  const brands = [
    {
      name: 'Google',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg',
      desc: t('brand-google-desc'),
      sustainabilityUrl: 'https://sustainability.google/'
    },
    {
      name: 'Microsoft',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/9/96/Microsoft_logo_%282012%29.svg',
      desc: t('brand-microsoft-desc'),
      sustainabilityUrl: 'https://www.microsoft.com/en-us/corporate-responsibility/sustainability'
    },
    {
      name: 'Amazon',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg',
      desc: t('brand-amazon-desc'),
      sustainabilityUrl: 'https://sustainability.aboutamazon.com/'
    },
    {
      name: 'Tesla',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/e/e8/Tesla_logo.png',
      desc: t('brand-tesla-desc'),
      sustainabilityUrl: 'https://www.tesla.com/impact'
    },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-neutral-800 mb-4">
            {t('big-brands-title')}
          </h2>
          <p className="text-lg text-neutral-600 max-w-2xl mx-auto">
            {t('big-brands-subtitle')}
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {brands.map((brand) => (
            <a 
              key={brand.name} 
              href={brand.sustainabilityUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-neutral-50 rounded-2xl shadow-md p-6 flex flex-col items-center hover:shadow-xl hover:scale-105 transition-all duration-300 cursor-pointer group"
            >
              <img 
                src={brand.logo} 
                alt={brand.name + ' logo'} 
                className="h-12 w-auto mb-4 grayscale group-hover:grayscale-0 transition-all duration-300" 
              />
              <div className="text-xl font-bold text-primary-700 mb-2 group-hover:text-primary-600 transition-colors">
                {brand.name}
              </div>
              <div className="text-sm text-neutral-700 text-center group-hover:text-neutral-800 transition-colors">
                {brand.desc}
              </div>
              <div className="mt-4 text-xs text-primary-500 font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                {t('brand-visit-sustainability')}
              </div>
            </a>
          ))}
        </div>
        <div className="mt-10 text-center">
          <span className="inline-block bg-primary-100 text-primary-700 font-semibold px-6 py-3 rounded-full shadow">
            {t('big-brands-cta')}
          </span>
        </div>
      </div>
    </section>
  );
};

export default BigBrandsZeroCarbon; 